import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SyncoUserAvatarIcon = (props: IconProps) => (
  <Icon w="32px" h="32px" viewBox="0 0 32 32" {...props} fill="none">
    <mask
      id="mask0_4664_30600"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <circle cx="16" cy="16" r="15.5" fill="#DADADA" stroke="black" />
    </mask>
    <g mask="url(#mask0_4664_30600)" />
    <g clipPath="url(#clip0_4664_30600)">
      <path
        d="M21.8519 12.7256H10.9528C9.44812 12.7256 8.22803 13.9627 8.22803 15.4883C8.22803 17.014 9.44812 18.2511 10.9528 18.2511H21.8519C23.3566 18.2511 24.5767 19.4881 24.5767 21.0138V15.4883C24.5767 13.9627 23.3566 12.7256 21.8519 12.7256Z"
        fill="url(#paint0_linear_4664_30600)"
      />
      <path
        d="M21.8518 18.251H16.4023C14.8976 18.251 13.6775 19.4881 13.6775 21.0137V23.7764V26.5392C13.6775 25.0135 14.8976 23.7764 16.4023 23.7764H21.8518C23.3565 23.7764 24.5766 22.5394 24.5766 21.0137C24.5766 19.4881 23.3565 18.251 21.8518 18.251Z"
        fill="url(#paint1_linear_4664_30600)"
      />
      <path
        d="M10.9528 7.2002C9.44813 7.2002 8.22803 8.43729 8.22803 9.96293V15.4884C8.22803 13.9628 9.44813 12.7257 10.9528 12.7257H16.4024C17.9071 12.7257 19.1272 11.4886 19.1272 9.96293V7.2002H10.9528Z"
        fill="url(#paint2_linear_4664_30600)"
      />
    </g>
    <circle cx="16" cy="16" r="15.5" stroke="#D6D6D6" />
    <defs>
      <linearGradient
        id="paint0_linear_4664_30600"
        x1="8.22803"
        y1="16.8697"
        x2="24.5767"
        y2="16.8697"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F16431" />
        <stop offset="0.36" stopColor="#F68F1D" />
        <stop offset="0.79" stopColor="#FCBD08" />
        <stop offset="1" stopColor="#FFCF00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4664_30600"
        x1="13.6775"
        y1="22.3951"
        x2="24.5766"
        y2="22.3951"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F16431" />
        <stop offset="0.34" stopColor="#EE6130" />
        <stop offset="0.56" stopColor="#E85830" />
        <stop offset="0.75" stopColor="#DC492F" />
        <stop offset="0.91" stopColor="#CC352D" />
        <stop offset="1" stopColor="#C1272D" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4664_30600"
        x1="8.22803"
        y1="11.3443"
        x2="19.1272"
        y2="11.3443"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9500" />
        <stop offset="0.09" stopColor="#FFA900" />
        <stop offset="0.19" stopColor="#FFBA00" />
        <stop offset="0.32" stopColor="#FFC600" />
        <stop offset="0.5" stopColor="#FFCD00" />
        <stop offset="1" stopColor="#FFCF00" />
      </linearGradient>
      <clipPath id="clip0_4664_30600">
        <rect
          width="24.6857"
          height="19.2"
          fill="white"
          transform="translate(4 7.2002)"
        />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(SyncoUserAvatarIcon);
